import React from "react";
import "./termsprivacy.css";

import { GoArrowRight } from "react-icons/go";

const TermsAndConditions = () => {
  return (
    <div className="maindiv">
      <h2>Terms And Conditions</h2>
      <div className="termsandrivacydiv">
        <p>
          Thank you for choosing Bhookr! To ensure a smooth and satisfying
          experience, please review the following terms carefully before
          subscribing
        </p>
        <ul>
          <li>
            <span>
              <GoArrowRight />
            </span>
            Advance Intimation for Pausing Meals Pausing or rescheduling meals
            requires at least one day’s notice. Requests made on the same day
            will not be accommodated, and the meal will be counted.
          </li>
          <li>
            <span className="text-[#de0101] mt-[5px] ">
              <GoArrowRight />
            </span>

            <p>
              <p className="text-[#de0101] "> Delivery Timings</p>
              Meals will only be delivered within the slot timings specified by
              Bhookr. Customized delivery timings are not available. For
              flexibility, you may choose to pick up your meal from our outlet
              during operating hours.
            </p>
          </li>
          <li>
            <span className="text-[#de0101] mt-[5px] ">
              <GoArrowRight />
            </span>

            <p>
              <p className="text-[#de0101]"> Meal Modifications</p>
              Changes to diet plans, delivery addresses, or preferences must be
              communicated one day in advance.
            </p>
          </li>
          <li>
            <span className="text-[#de0101] mt-[5px] ">
              <GoArrowRight />
            </span>

            <p>
              <p className="text-[#de0101]  "> No Refund Policy</p>
              Bhookr operates under a strict no refund policy for all
              subscriptions.
            </p>
          </li>
          <li>
            <span className="text-[#de0101] mt-[5px] ">
              <GoArrowRight />
            </span>

            <p>
              <p className="text-[#de0101] ">Meal Preparation Guidelines</p>
              Our meals are curated by professional chefs and nutritionists.
              While we consider your likes and dislikes, personalized cooking
              preferences are not accommodated.
            </p>
          </li>
          <li>
            <span className="text-[#de0101] mt-[5px] ">
              <GoArrowRight />
            </span>

            <p>
              <p className="text-[#de0101] "> Quantity Adjustments</p>
              Any changes to the quantity of meals may incur additional charges.
            </p>
          </li>
          <li>
            <span className="text-[#de0101] mt-[5px] ">
              <GoArrowRight />
            </span>

            <p>
              <p className="text-[#de0101] ">
                {" "}
                Fitness Responsibility Disclaimer
              </p>
              Fitness transformations depend on multiple factors, including
              diet, workouts, sleep, and lifestyle habits. Bhookr is not
              responsible if your desired fitness results are not achieved. We
              do not promise specific weight loss or gain but are committed to
              helping you achieve a healthier lifestyle.
            </p>
          </li>
          <li>
            <span className="text-[#de0101] mt-[5px] ">
              <GoArrowRight />
            </span>

            <p>
              <p className="text-[#de0101]"> Spot Cancellations</p>
              Spot cancellations of meals are not permitted and will result in
              the meal being counted.
            </p>
          </li>
          <li>
            <span className="text-[#de0101]  ">
              <GoArrowRight />
            </span>

            <p>
              <p className="text-[#de0101] mt-[5px] "> Meal Replacement</p>
              Missed meals due to non-communication or late requests will not be
              replaced or refunded.
            </p>
          </li>
          <li>
            <span className="text-[#de0101] mt-[5px] ">
              <GoArrowRight />
            </span>

            <p>
              <p className="text-[#de0101] "> Allergen Responsibility</p>
              It is the client’s responsibility to notify Bhookr of any food
              allergies before subscribing. While we take utmost care,
              cross-contamination cannot be guaranteed.
            </p>
          </li>
          <li>
            <span className="text-[#de0101] mt-[5px] ">
              <GoArrowRight />
            </span>

            <p>
              <p className="text-[#de0101] ">
                {" "}
                Subscription Duration Commitment
              </p>
              Subscriptions must be used within the specified time frame.
              Extensions will not be granted unless explicitly agreed upon.
            </p>
          </li>
          <li>
            <span className="text-[#de0101] mt-[5px] ">
              <GoArrowRight />
            </span>

            <p>
              <p className="text-[#de0101] "> Payment Terms</p>
              Full payment must be made before the start of the subscription.
              Partial payments are not accepted.
            </p>
          </li>
          <li>
            <span className="text-[#de0101] mt-[5px] ">
              <GoArrowRight />
            </span>

            <p>
              <p className="text-[#de0101] "> Non-Transferability</p>
              Subscriptions are non-transferable and cannot be shared with
              others.
            </p>
          </li>
          <li>
            <span className="text-[#de0101] mt-[5px] ">
              <GoArrowRight />
            </span>

            <p>
              <p className="text-[#de0101]  ">Client Communication</p>
              Official communication will be made through WhatsApp, email, or
              calls. It is the client’s responsibility to check for updates.
            </p>
          </li>
          <li>
            <span className="text-[#de0101] mt-[5px] ">
              <GoArrowRight />
            </span>

            <p>
              <p className="text-[#de0101] ">Damaged Deliveries</p>
              In the rare event of meal damage during delivery, it must be
              reported within 2 hours for resolution.
            </p>
          </li>
          <li>
            <span className="text-[#de0101] mt-[5px] ">
              <GoArrowRight />
            </span>

            <p>
              <p className="text-[#de0101]  "> Dietary Changes</p>
              Significant diet modifications may require consultation with
              Bhookr’s nutritionist and may incur additional charges.
            </p>
          </li>
          <li>
            <span className="text-[#de0101] mt-[5px] ">
              <GoArrowRight />
            </span>

            <p>
              <p className="text-[#de0101]"> Cancellation Policy</p>
              Subscriptions cannot be canceled. However, meals can be paused and
              resumed at a later date, provided one day’s notice is given.
            </p>
          </li>
          <li>
            <span className="text-[#de0101] mt-[5px] ">
              <GoArrowRight />
            </span>

            <p>
              <p className="text-[#de0101]"> Shipping Policy</p>
              <p>
                We deliver freshly prepared meals everyday according to your
                subscription plan, ensuring timely delivery for breakfast
                (morning), lunch (afternoon), and dinner (evening).
              </p>
              <p>
                Please note that for same-day delivery, orders must be placed in
                advance to ensure timely preparation and delivery of breakfast,
                lunch, and dinner on the same day.
              </p>
            </p>
          </li>
        </ul>
        <p className="my-[20px]">
          We value your cooperation in adhering to these guidelines to help us
          provide exceptional service.
        </p>
        <p className="text-[#de0101] my-[20px]">
          Thank you for trusting Bhookr for your health and nutrition needs!
        </p>
      </div>
    </div>
  );
};

export default TermsAndConditions;
